(function () {
  'use strict';

  function initScrollToTop() {
    var scrollBtn = document.getElementById('AzriaScrollTop');
    if (!scrollBtn) return;

    var showThreshold = 300;
    var ticking = false;

    function updateVisibility() {
      if (window.pageYOffset > showThreshold) {
        scrollBtn.classList.add('visible');
      } else {
        scrollBtn.classList.remove('visible');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    }

    function scrollToTop(e) {
      if (e) e.preventDefault();
      var supportsSmooth =
        'scrollBehavior' in document.documentElement.style;

      if (supportsSmooth) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        var scrollStep = -window.pageYOffset / 20;
        var scrollInterval = setInterval(function () {
          if (window.pageYOffset !== 0) {
            window.scrollBy(0, scrollStep);
          } else {
            clearInterval(scrollInterval);
          }
        }, 15);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    scrollBtn.addEventListener('click', scrollToTop);

    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollToTop);
  } else {
    initScrollToTop();
  }
})();
